import fr from 'facet-rest';

const AccountSupportTableOverride = fr.metaOverride()
  .overrideAll({
    readonly: true,
    _hideLabel: true,
    hidden: true,
    _customProps: {
      noWrap: true,
      hasTooltip: true,
    },
  })
  .nameOverride('timestamp', { ordinal: 1, hidden: false })
  .nameOverride('institution_name', { ordinal: 2, hidden: false })
  .nameOverride('eventName', { ordinal: 3, hidden: false })
  .nameOverride('error_code', { ordinal: 4, hidden: false })
  .nameOverride('error_type', { ordinal: 5, hidden: false })
  .nameOverride('error_message', {
    ordinal: 6,
    hidden: false,
    _customProps: {
      minWidth: '500px',
    },
  });


export default AccountSupportTableOverride;
